<script setup>
import SearchAPI from '@/services/services'
</script>

<template>
    <div class="navbar m-0 p-0 overflow-clip justify-center">
        <img :src="getCountyLogo()" class="float-left w-32 mr-5" />
        <div class="text-2xl md:text-3xl lg:text-5xl font-bold">{{county_name}} Land Redemption</div>
    </div>
    <div class="hero" v-show="nav_section=='home'">
        <div class="hero-content text-center text-accent-content">
            <div>
                <div class="text-xl font-bold">Welcome to the {{county_name}} Land Redemption Portal where delinquent tax can be paid online.</div>

                <div v-html="template_text_main" class="w-full block"></div>

                <button class="btn btn-accent" v-on:click="nav_section='search';">Get Started</button>
                <br />
                <br />
                Powered by DuProcess&reg; ver: {{application_version}}
            </div>
        </div>
    </div>
    <div class="hero" v-show="nav_section=='search'">
        <div class="hero-content w-3/4">
            <div class="card w-full bg-base-100 shadow-xl">
                <div class="card-body p-4" id="criteria_card">
                    <h2 class="card-title">Land Redemption Search Criteria</h2>
                    <p>(Enter one or more criteria.)</p>
                    <label class="label p-0" for="criteria_ppin">PPIN</label>
                    <input type="text" id="criteria_ppin" placeholder="PPIN" v-model="criteria_ppin" @keyup.enter="searchRecords" class="input input-bordered w-full max-w-xs bg-white text-black" />
                    <label class="label p-0" for="criteria_year">Tax Year</label>
                    <input type="text" id="criteria_year" placeholder="Tax Year" v-model="criteria_year" @keyup.enter="searchRecords" class="input input-bordered w-full max-w-xs bg-white text-black" />
                    <label class="label p-0" for="criteria_name">Owner Name</label>
                    <input type="text" id="criteria_name" placeholder="Ex: Hancock John or ABC Printing" v-model="criteria_name" @keyup.enter="searchRecords" class="input input-bordered w-full max-w-xs bg-white text-black" />
                    <label class="label p-0" for="criteria_parcel">Parcel Number</label>
                    <input type="text" id="criteria_parcel" placeholder="Parcel Number" v-model="criteria_parcel" @keyup.enter="searchRecords" class="input input-bordered w-full max-w-xs bg-white text-black" />
                    <span><input type="checkbox" v-model="criteria_unredeemed" class="checkbox checkbox-primary" :checked="kiosk_mode || unredeemed_checked" :disabled="kiosk_mode" /> Un-Redeemed Only</span>
                    <div class="card-actions justify-end">
                        <button class="btn btn-accent" v-on:click="searchRecords()" v-if="is_loading == false">Search</button>
                        <button class="btn glass" v-if="is_loading == true">
                            <span class="loading loading-spinner"></span>
                            loading
                        </button>
                        <button class="btn btn-warning" v-on:click="clearSearch()">Clear</button>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <br />
        <br />
    </div>
    <div class="flex items-center justify-center h-fit" v-show="nav_section=='results'">
        <div class="overflow-auto card w-full h-{450} bg-blue-200 text-black">
            <div class="card-body p-2">
                <table id="search_grid" class="table-compact w-full"></table>
                <div class="flex-row text-right w-full">
                    <button class="btn btn-primary" v-if="!kiosk_mode && export_enabled" v-on:click="exportResults('PDF')">Export Results as PDF</button>
                    <button class="btn btn-secondary" v-if="!kiosk_mode && export_enabled" v-on:click="exportResults('CSV')">Export Results as Excel/CSV</button>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    </div>
    <div class="hero" v-show="nav_section=='details'">
        <div class="items-start flex flex-col md:flex-row">
            <div class="card w-96 bg-base-100 shadow-xl align-top mr-2" v-show="isAvailableForPayment()">
                <div class="btn glass">
                    <span>PPIN:{{redemption_case.Ppin}} / Year: {{redemption_case.TaxYear}} / Parcel: {{redemption_case.ParcelNumber}}</span>
                </div>
                <div class="card-body pt-0">
                    <h2 class="card-title">Outstanding Tax Assessments</h2>
                    <div v-for="item in tax_year_list" class="year_assessment">
                        <span v-text="item.Year"></span> - <input type="checkbox" name="pay_year" :value="item.Year" checked /> <span v-text="item.Value"></span>
                    </div>
                    <p>List of outstanding assessments for prior years. Use the "Pay" button below to use a credit card to remit payment for selected year items.</p>
                    <div>
                        <label class="label">First Name</label>
                        <input type="text" v-model="first_name" placeholder="First Name" class="input input-bordered w-full max-w-xs bg-white text-black" /><br />
                        <label class="label">Last Name</label>
                        <input type="text" v-model="last_name" placeholder="Last Name" class="input input-bordered w-full max-w-xs bg-white text-black" /><br />
                        <label class="label">Email</label>
                        <input type="email" v-model="email" placeholder="Email" class="input input-bordered w-full max-w-xs bg-white text-black" /><br />
                        <label class="label">Phone</label>
                        <input type="tel" v-model="phone" placeholder="Phone" class="input input-bordered w-full max-w-xs bg-white text-black" /><br />
                        <label class="label">Address</label>
                        <input type="text" v-model="address" placeholder="Address" class="input input-bordered w-full max-w-xs bg-white text-black" /><br />
                        <label class="label">City/State/Zip</label>
                        <input type="text" v-model="city" placeholder="City" class="input input-bordered max-w-xs bg-white text-black w-44" />
                        <input type="text" v-model="state" placeholder="ST" class="input input-bordered max-w-xs bg-white text-black w-14" maxlength="2" />
                        <input type="text" v-model="zip" placeholder="Zip" class="input input-bordered max-w-xs bg-white text-black w-20" maxlength="5" /><br />
                    </div>
                    <div class="card-actions justify-end">
                        <button class="btn btn-primary" v-on:click="paySelectedItems()">Pay delinquent tax for selected years</button>
                    </div>
                    <div v-html="template_text_online_payment" class="w-full block"></div>
                    <!--<div>
                        <label class="label">NOTICE: Pursuant to Miss. Code Ann. Section 27-35-63, all persons seeking to redeem properties struck off to the State of Mississippi, in addition to satisfying delinquent property taxes, damages and costs for which a parcel was sold to the State, must also satisfy all taxes, interest and penalties, if any, that have been levied up to and including the date of redemption. To satisfy current taxes, interest, and penalties, contact the Rankin County Tax Collector. </label>
                    </div>-->
                </div>
                <br />
                <br />
            </div>
            <div>
                <div class="text-xl btn glass text-accent-content">
                    <span>PPIN:{{redemption_case.Ppin}} / Year: {{redemption_case.TaxYear}} / Parcel: {{redemption_case.ParcelNumber}}</span>
                </div>
                <div v-if="redemption_case.VoidFlag == 'Y'">
                    <span class="text-red-500 font-bold text-lg">
                        VOIDED for the {{redemption_case.TaxYear}} tax year.
                    </span>
                </div>
                <div v-else>
                    <div v-if="redemption_case.RedemptionDate == null">
                        <span class="text-red-500 font-bold text-lg">
                            Record has NOT been redeemed for the {{redemption_case.TaxYear}} tax year.
                        </span>
                    </div>
                    <div v-else>
                        <span class="text-green-700 font-bold text-lg">
                            <span v-if="redemption_case.Conveyance.toString().toLowerCase() == 'true'">
                                Record has been conveyed for the {{redemption_case.TaxYear}} tax year.
                            </span>
                            <span v-else>
                                Record has been redeemed for the {{redemption_case.TaxYear}} tax year.
                            </span>
                        </span>
                    </div>
                </div>
                <div v-if="redemption_case.MaturedToStateFlag != 'N'">
                    <span class="text-red-500 font-bold text-lg">
                        {{redemption_case.MaturedToStateFlag}}
                    </span>
                </div>
                <div class="flex">
                    <label class="label h-9 text-accent-content">Legal Description</label><label class="label font-bold text-accent-content" v-html="redemption_case.ExtendedLegal"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Tax Sale Date</label><label class="label font-bold text-accent-content" v-text="formatDate(redemption_case.SaleDate)"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Redemption Date</label><label class="label font-bold text-accent-content" v-text="formatDate(redemption_case.RedemptionDate)"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Owner Name</label><label class="label font-bold text-accent-content" v-text="redemption_case.PropertyOwner"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Owner Address</label><label class="label font-bold text-accent-content" v-text="redemption_case.OwnerAddress"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Sold to Name</label><label class="label font-bold text-accent-content" v-text="redemption_case.SoldToName"></label>
                </div>
                <div class="flex" v-if="show_purchaser_address">
                    <label class="label text-accent-content">Sold to Address</label><label class="label font-bold text-accent-content" v-text="redemption_case.SoldToAddress"></label>
                </div>
                <div class="flex">
                    <label class="label text-accent-content">Effective Date (payoff)</label><label class="label font-bold text-accent-content" v-text="formatDate(redemption_case.EffectiveDate)"></label>
                </div>
                <table class="table table-zebra bg-base-100">
                    <thead>
                        <tr>
                            <th>Itemized Fees</th>
                            <th>County</th>
                            <th>City</th>
                            <th>School</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="">
                            <td>1. Amount of Delinquent Taxes:</td>
                            <td><label v-text="redemption_case.LR0101"></label></td>
                            <td><label v-text="redemption_case.LR0102"></label></td>
                            <td><label v-text="redemption_case.LR0103"></label></td>
                        </tr>
                        <tr class="">
                            <td>2. Interest from 02/01 to sale month:</td>
                            <td><label v-text="redemption_case.LR0201"></label></td>
                            <td><label v-text="redemption_case.LR0202"></label></td>
                            <td><label v-text="redemption_case.LR0203"></label></td>
                        </tr>
                        <tr class="">
                            <td>3. Publishers Fee $1.50 per publication:</td>
                            <td><label v-text="redemption_case.LR0301"></label></td>
                            <td><label v-text="redemption_case.LR0302"></label></td>
                            <td><label v-text="redemption_case.LR0303"></label></td>
                        </tr>
                        <tr class="">
                            <td>4. Sub-total (amount due at tax sale):</td>
                            <td><label v-text="redemption_case.LR0401"></label></td>
                            <td>Sold For: <label v-text="redemption_case.LR0402"></label></td>
                            <td>Excess: <label v-text="redemption_case.LR0403"></label></td>
                        </tr>
                        <tr class="">
                            <td>5. Purchase interest:</td>
                            <td><label v-text="redemption_case.LR0501"></label></td>
                            <td><label v-text="redemption_case.LR0502"></label></td>
                            <td><label v-text="redemption_case.LR0503"></label></td>
                        </tr>
                        <tr class="">
                            <td>6. Damages of 5 Line 1 (sales prior 7/1/94):</td>
                            <td><label v-text="redemption_case.LR0601"></label></td>
                            <td><label v-text="redemption_case.LR0602"></label></td>
                            <td><label v-text="redemption_case.LR0603"></label></td>
                        </tr>
                        <tr class="">
                            <td>7. Total Amount Due to Purchaser:</td>
                            <td><label v-text="redemption_case.LR0701"></label></td>
                            <td><label v-text="redemption_case.LR0702"></label></td>
                            <td><label v-text="redemption_case.LR0703"></label></td>
                        </tr>
                        <tr>
                            <td colspan="5">&nbsp;</td>
                        </tr>
                        <tr class="section_2">
                            <td class="font-bold">County Costs Itemized</td>
                            <td>County</td>
                            <td>City</td>
                            <td>School</td>
                        </tr>
                        <tr class="">
                            <td>8. Damages (only for sales from 7/1/94):</td>
                            <td><label v-text="redemption_case.LR0801"></label></td>
                            <td><label v-text="redemption_case.LR0802"></label></td>
                            <td><label v-text="redemption_case.LR0803"></label></td>
                        </tr>
                        <tr class="">
                            <td>9. County actual postage fee:</td>
                            <td><label v-text="redemption_case.LR0901"></label></td>
                            <td><label v-text="redemption_case.LR0902"></label></td>
                            <td><label v-text="redemption_case.LR0903"></label></td>
                        </tr>
                        <tr class="">
                            <td>10. Publishers actual fee (paid by county):</td>
                            <td><label v-text="redemption_case.LR1001"></label></td>
                            <td><label v-text="redemption_case.LR1002"></label></td>
                            <td><label v-text="redemption_case.LR1003"></label></td>
                        </tr>
                        <tr class="">
                            <td>11. Accrued taxes for year:</td>
                            <td><label v-text="redemption_case.LR1101"></label></td>
                            <td><label v-text="redemption_case.LR1102"></label></td>
                            <td><label v-text="redemption_case.LR1103"></label></td>
                        </tr>
                        <tr class="">
                            <td>12. Interest on line 11:</td>
                            <td><label v-text="redemption_case.LR1201"></label></td>
                            <td><label v-text="redemption_case.LR1202"></label></td>
                            <td><label v-text="redemption_case.LR1203"></label></td>
                        </tr>
                        <tr class="">
                            <td>13. Accrued taxes for year:</td>
                            <td><label v-text="redemption_case.LR1301"></label></td>
                            <td><label v-text="redemption_case.LR1302"></label></td>
                            <td><label v-text="redemption_case.LR1303"></label></td>
                        </tr>
                        <tr class="">
                            <td>14. Interest on line 13:</td>
                            <td><label v-text="redemption_case.LR1401"></label></td>
                            <td><label v-text="redemption_case.LR1402"></label></td>
                            <td><label v-text="redemption_case.LR1403"></label></td>
                        </tr>
                        <tr class="">
                            <td>14a. Costs incident to sale:</td>
                            <td><label v-text="redemption_case.LR14a"></label></td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr class="">
                            <td>15. TOTAL AMOUNT DUE:</td>
                            <td><label v-text="redemption_case.LR1501"></label></td>
                            <td><label v-text="redemption_case.LR1502"></label></td>
                            <td><label v-text="redemption_case.LR1503"></label></td>
                        </tr>
                        <tr>
                            <td colspan="5">&nbsp;</td>
                        </tr>
                        <tr class="section_3">
                            <td class="font-bold">Sheriff Costs Itemized</td>
                            <td>Rate</td>
                            <td>Quantity</td>
                            <td>Fees</td>
                        </tr>
                        <tr class="">
                            <td>16. 1st Notice (Section 27-43-3):</td>
                            <td><label v-text="redemption_case.LR16RTE"></label></td>
                            <td><label v-text="redemption_case.LR16QTY"></label></td>
                            <td><label v-text="redemption_case.LR1601"></label></td>
                        </tr>
                        <tr class="">
                            <td>17. 2nd Notice (Section 27-43-3):</td>
                            <td><label v-text="redemption_case.LR17RTE"></label></td>
                            <td><label v-text="redemption_case.LR17QTY"></label></td>
                            <td><label v-text="redemption_case.LR1701"></label></td>
                        </tr>
                        <tr class="">
                            <td>18. TOTAL AMOUNT DUE TO SHERIFF:</td>
                            <td><label v-text="redemption_case.LR1801"></label></td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                        </tr>
                        <tr>
                            <td colspan="5">&nbsp;</td>
                        </tr>
                        <tr class="section_4">
                            <td class="font-bold">Chancery Clerk Fees</td>
                            <td>Rate</td>
                            <td>Quantity</td>
                            <td>Fees</td>
                        </tr>
                        <tr class="">
                            <td>19. Identify record owners:</td>
                            <td><label v-text="redemption_case.LR19RTE"></label></td>
                            <td><label v-text="redemption_case.LR19QTY"></label></td>
                            <td><label v-text="redemption_case.LR1901"></label></td>
                        </tr>
                        <tr class="">
                            <td>20. Recording list, each subdivision lot:</td>
                            <td><label v-text="redemption_case.LR20RTE"></label></td>
                            <td><label v-text="redemption_case.LR20QTY"></label></td>
                            <td><label v-text="redemption_case.LR2001"></label></td>
                        </tr>
                        <tr class="">
                            <td>21. Issue 1st sheriffs notice:</td>
                            <td><label v-text="redemption_case.LR21RTE"></label></td>
                            <td><label v-text="redemption_case.LR21QTY"></label></td>
                            <td><label v-text="redemption_case.LR2101"></label></td>
                        </tr>
                        <tr class="">
                            <td>22. Mail 1st owners notice:</td>
                            <td><label v-text="redemption_case.LR22RTE"></label></td>
                            <td><label v-text="redemption_case.LR22QTY"></label></td>
                            <td><label v-text="redemption_case.LR2201"></label></td>
                        </tr>
                        <tr class="">
                            <td>23. Issue 2nd sheriffs notice:</td>
                            <td><label v-text="redemption_case.LR23RTE"></label></td>
                            <td><label v-text="redemption_case.LR23QTY"></label></td>
                            <td><label v-text="redemption_case.LR2301"></label></td>
                        </tr>
                        <tr class="">
                            <td>24. Mail 2nd owners notice:</td>
                            <td><label v-text="redemption_case.LR24RTE"></label></td>
                            <td><label v-text="redemption_case.LR24QTY"></label></td>
                            <td><label v-text="redemption_case.LR2401"></label></td>
                        </tr>
                        <tr class="">
                            <td>25. Issue each lienor notice:</td>
                            <td><label v-text="redemption_case.LR25RTE"></label></td>
                            <td><label v-text="redemption_case.LR25QTY"></label></td>
                            <td><label v-text="redemption_case.LR2501"></label></td>
                        </tr>
                        <tr class="">
                            <td>26. Publishers actual fee, if paid by clerk:</td>
                            <td><label v-text="redemption_case.LR26RTE"></label></td>
                            <td><label v-text="redemption_case.LR26QTY"></label></td>
                            <td><label v-text="redemption_case.LR2601"></label></td>
                        </tr>
                        <tr class="">
                            <td>27. Recording each redemption:</td>
                            <td><label v-text="redemption_case.LR27RTE"></label></td>
                            <td><label v-text="redemption_case.LR27QTY"></label></td>
                            <td><label v-text="redemption_case.LR2701"></label></td>
                        </tr>
                        <tr class="">
                            <td>28. Abstracting each subdivision lot:</td>
                            <td><label v-text="redemption_case.LR28RTE"></label></td>
                            <td><label v-text="redemption_case.LR28QTY"></label></td>
                            <td><label v-text="redemption_case.LR2801"></label></td>
                        </tr>
                        <tr class="">
                            <td>29. Certify amount to redeem:</td>
                            <td><label v-text="redemption_case.LR29RTE"></label></td>
                            <td><label v-text="redemption_case.LR29QTY"></label></td>
                            <td><label v-text="redemption_case.LR2901"></label></td>
                        </tr>
                        <tr class="">
                            <td>30. Certify release from sale:</td>
                            <td><label v-text="redemption_case.LR30RTE"></label></td>
                            <td><label v-text="redemption_case.LR30QTY"></label></td>
                            <td><label v-text="redemption_case.LR3001"></label></td>
                        </tr>
                        <tr class="section_5">
                            <td colspan="5">
                                <div class="float-right">============================================</div>
                            </td>
                        </tr>
                        <tr class="">
                            <td>31. Sub Total 19-30, 35-37:</td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                            <td><label v-text="redemption_case.LR3101"></label></td>
                        </tr>
                        <tr class="">
                            <td>32. Lines 7,15, 18, 31:</td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                            <td><label v-text="redemption_case.LR3201"></label></td>
                        </tr>
                        <tr class="">
                            <td>33. Redemption fee 3% X line 32:</td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                            <td><label v-text="redemption_case.LR3301"></label></td>
                        </tr>
                        <tr class="">
                            <td>34. TOTAL AMOUNT DUE TO CHANCERY CLERK:</td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                            <td><label v-text="redemption_case.LR3401"></label></td>
                        </tr>
                        <tr class="">
                            <td>35. Courtesy Letter:</td>
                            <td><label v-text="redemption_case.LR35RTE"></label></td>
                            <td><label v-text="redemption_case.LR35Qty"></label></td>
                            <td><label v-text="redemption_case.LR3501"></label></td>
                        </tr>
                        <tr class="">
                            <td>36. Archive:</td>
                            <td><label v-text="redemption_case.LR36RTE"></label></td>
                            <td><label v-text="redemption_case.LR36Qty"></label></td>
                            <td><label v-text="redemption_case.LR3601"></label></td>
                        </tr>
                        <tr class="">
                            <td>37. Affidavit:</td>
                            <td><label v-text="redemption_case.LR37RTE"></label></td>
                            <td><label v-text="redemption_case.LR37Qty"></label></td>
                            <td><label v-text="redemption_case.LR3701"></label></td>
                        </tr>
                        <tr class="">
                            <td class="font-bold">38. GRAND TOTAL</td>
                            <td><label id=""></label></td>
                            <td><label id=""></label></td>
                            <td><label v-text="grand_total" class="font-bold"></label></td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
    <div class="btm-nav">
        <button :class="[nav_section == 'home' ? 'active bg-blue-200 text-blue-600' : 'bg-blue-100']" v-on:click="navigate('home')">
            <svg xmlns="http://www.w3.org/2000/svg" class="" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
            <span class="btm-nav-label">Home</span>
        </button>
        <button :class="[nav_section == 'search' ? 'active bg-blue-200 text-blue-600' : 'bg-blue-100']" v-on:click="navigate('search')">
            <svg xmlns="http://www.w3.org/2000/svg" class="" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z" /></svg>
            <span class="btm-nav-label">Search</span>
        </button>
        <button :class="[nav_section == 'results' ? 'active bg-blue-200 text-blue-600' : 'bg-blue-100']" v-on:click="navigate('results')">
            <svg xmlns="http://www.w3.org/2000/svg" class="" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
            <span class="btm-nav-label">Results</span>
        </button>
        <button :class="[nav_section == 'details' ? 'active bg-blue-200 text-blue-600' : 'bg-blue-100']" v-on:click="navigate('details')">
            <svg xmlns="http://www.w3.org/2000/svg" class="" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span class="btm-nav-label">Details</span>
        </button>
    </div>

    <!-- Put this part before </body> tag -->
    <input type="checkbox" id="checkout-modal" class="modal-toggle" v-on:change="modalToggle" />
    <div class="modal" role="dialog">
        <div class="rounded-md p-4 bg-base-200 relative w-full md:w-[1150px] border border-solid border-white">
            <label for="checkout-modal" class="btn btn-sm btn-circle absolute right-2 top-2 ring-2 hover:ring-4 ring-black bg-red-200">X</label>
            <div v-html="checkout_page_text" class="w-[1150px]"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LandRedemption',
    props: {
        msg: String
    },
    data() {
        return {
            nav_section: 'home',
            template_text_main: 'Setup the LAND_REDEMPTION_WEB_PAGE_TEXT <strong>custom default</strong> for onscreen text.<br />You may call our support line at 866-256-0673',
            criteria_ppin: '',
            criteria_year: '',
            criteria_name: '',
            criteria_parcel: '',
            criteria_unredeemed: false,
            redemption_case: {},
            grand_total: 0,
            county_name: 'DuProcess County, MS',
            tax_year_list: [],
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            address: '',
            city:  '',
            state: '',
            zip: '',
            checkout_page_text: '',
            kiosk_mode: false,
            application_version: '',
            unredeemed_checked: false,
            is_loading: false,
            kl: '',
            has_credit_card_merchant: false,
            show_purchaser_address: true,
            export_enabled: true
        }
    },
    mounted: function () {
        var vm = this;
        SearchAPI.getApplicationVersion()
            .then(function (data) {
                if (data == null || data == "") return;
                vm.application_version = data;
            });
        SearchAPI.getCustomerInfo()
            .then(function (data) {
                if (data == null || data == "") return;
                vm.county_name = data.customer_name;
            });
        SearchAPI.getTemplateText("LAND_REDEMPTION_WEB_PAGE_TEXT")
            .then(data => {
                //console.log(data);
                if (data == null || data == "") return;
                data = data.replace("{\"template\":\"", "");
                data = data.replace("\"}", "");
                data = data.replace(new RegExp('\r?\n', 'g'), '');
                vm.template_text_main = data;
            })
        SearchAPI.getTemplateText("LAND_REDEMPTION_WEB_ONLINE_PAYMENT")
            .then(data => {
                //console.log(data);
                if (data == null || data == "") return;
                data = data.replace("{\"template\":\"", "");
                data = data.replace("\"}", "");
                data = data.replace(new RegExp('\r?\n', 'g'), '');
                vm.template_text_online_payment = data;
            })
        SearchAPI.getCustomDefault("LR_WEB_UNREDEEMED_CHECKED")
            .then(data => {
                vm.unredeemed_checked = (data == "Y");
            })
        SearchAPI.getCustomDefault("LR_SHOW_PURCHASER_ADDRESS", "Y")
            .then(data => {
                vm.show_purchaser_address = (data == "Y");
            })
        SearchAPI.getCustomDefault("LR_POTAL_EXPORT_ENABLED", "Y")
            .then(data => {
                vm.export_enabled = (data == "Y");
            })
        SearchAPI.getCreditCardMerchant()
            .then(function (data) {
                if (data == null || data == "") return;
                if (data != "" && data != "NONE") {
                    vm.has_credit_card_merchant = true;
                }
            });
        this.setupGrid();
        this.searchURLqueryString();
    },
    methods: {
        getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        getCountyLogo() {
            try {
                return require('../assets/' + this.county_name + '.png');
            } catch (ex) {
                return require('../assets/DuProcess County, MS.png');
            }
        },
        navigate(section){
            this.nav_section = section;
        },
        searchURLqueryString() {
            var kiosk = this.getUrlParameter("kiosk");
            if (kiosk == "true") {
                this.kiosk_mode = true;
                this.nav_section = "search";
            }
            this.kl = this.getUrlParameter("kl");

            var ppin = this.getUrlParameter("ppin");
            if (ppin == "") {
                ppin = this.getUrlParameter("PPIN");
            }
            var year = this.getUrlParameter("year");
            if (year == "") {
                year = this.getUrlParameter("YEAR");
            }
            if (ppin != "") {
                this.criteria_ppin = ppin;
                this.criteria_year = year;
                this.searchRecords();
            }
        },
        searchRecords() {
            if (this.criteria_ppin == "" && this.criteria_name == "" && this.criteria_parcel == "") {
                alert("Please enter additional criteria before searching.");
                return;
            }
            var vm = this;
            var search_user_id = "1011"; //this is static (for now)
            this.is_loading = true;
            if (this.criteria_ppin != "") {
                this.criteria_ppin = this.criteria_ppin * 1; //make it numeric to drop leading zero
            }

            $("#search_grid").igGrid("dataSourceObject", []);
            $("#search_grid").igGrid("dataBind");

            SearchAPI.searchLandRecords(search_user_id, this.criteria_ppin, this.criteria_year, this.criteria_parcel, this.criteria_name, this.criteria_unredeemed, this.kiosk_mode)
                .then(function (data) {
                    vm.nav_section = "results";
                    vm.is_loading = false;

                    //console.log(data);

                    $("#search_grid").igGrid("option", "dataSource", data);
                    $('#search_grid').igGridSorting('sortColumn', 'TaxYear', 'desc');
                    setTimeout(function () {
                        $("#search_grid").css("width", "100%");
                    }, 1000);
                    if (data != null && data.length == 1) {
                        //select first item...
                        vm.loadRedemptionCase(data[0].Gin, data[0].TaxYear);
                        vm.loadAvailableAssessments(data[0].Gin);
                    }
                });
        },
        selectResult(evt, args) {
            if ($(args.row.element[0]).hasClass("ui-iggrid-groupedrow")) return; //grouping column, ignore
            var rowObject = args.owner.grid.findRecordByKey(args.row.id);
            var gin = rowObject.Gin;
            var tax_year = rowObject.TaxYear;
            //console.log("selected gin=" + gin);
            //console.log(rowObject.TaxYear);
            //console.log(rowObject['TaxYear']);
            //var cls = args.row.element.context.className;
            this.loadRedemptionCase(gin, tax_year);
            this.loadAvailableAssessments(gin);
        },
        loadAvailableAssessments(gin) {
            var vm = this;
            SearchAPI.getAvailableYears(gin)
                .then(function (data) {
                    vm.tax_year_list = [];
                    if (data == null) {
                        return;
                    }
                    vm.tax_year_list = data;
                    setTimeout(function () {
                        $($("[name='pay_year']")[0]).prop("disabled", "true");
                    }, 100);
                });
            //clear fields in expectation of new entry...
            this.first_name = "";
            this.last_name = "";
            this.email = "";
            this.phone = "";
            this.address = "";
            this.city = "";
            this.state = "";
            this.zip = "";
        },
        loadRedemptionCase(gin, tax_year) {
            $($("[name='accordion']")[0]).prop("checked", true);

            var vm = this;
            SearchAPI.loadRedemptionCase(gin, tax_year)
                .then(function (data) {
                    if (data == null) {
                        vm.redemption_case = {};
                        return;
                    }
                    const digits = new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
                    var months = vm.monthDiff(new Date(vm.formatDate(data.SaleDate)), new Date(vm.formatDate(data.EffectiveDate)));
                    months += 1; //offset for additional month
                    var line_5 = data.LR0401 * data.R05PCT * months;
                    data.LR0501 = digits.format(line_5);

                    var LR0401 = data.LR0401 * 1;
                    var LR0501 = line_5;
                    var LR0601 = data.LR0601 * 1;
                    var line_7 = LR0401 + LR0501 + LR0601;
                    data.LR0701 = digits.format(line_7);

                    var LR0801 = data.LR0801 * 1;
                    var LR0802 = data.LR0802 * 1;
                    var LR0803 = data.LR0803 * 1;
                    var LR0901 = data.LR0901 * 1;
                    var LR1001 = data.LR1001 * 1;
                    var LR1101 = data.LR1101 * 1;
                    var LR1102 = data.LR1102 * 1;
                    var LR1103 = data.LR1103 * 1;
                    var LR1201 = Math.round((LR1101 * 0.015 * (months + 5)) * 1000) / 1000;
                    var LR1202 = Math.round((LR1102 * 0.015 * (months + 5)) * 1000) / 1000;
                    var LR1203 = Math.round((LR1103 * 0.015 * (months + 5)) * 1000) / 1000;

                    var LR1301 = data.LR1301 * 1;
                    var LR1302 = data.LR1302 * 1;
                    var LR1303 = data.LR1303 * 1;
                    var LR1401 = data.LR1401 * 1;
                    var LR1402 = data.LR1402 * 1;
                    var LR1403 = data.LR1403 * 1;
                    var LR14a = data.LR14a * 1;
                    var line_15 = LR0801 + LR0802 + LR0803 + LR0901 + LR1001 + LR1101 + LR1102 + LR1103 + LR1201 + LR1202 + LR1203 + LR1301 + LR1302 + LR1303 + LR1401 + LR1402 + LR1403 + LR14a;
                    data.LR1501 = digits.format(line_15);

                    var LR1601 = data.LR1601 * 1;
                    var LR1701 = data.LR1701 * 1;
                    var line_18 = LR1601 + LR1701
                    data.LR1801 = digits.format(line_18);

                    var line_19 = data.LR1901 * 1;
                    var line_20 = data.LR2001 * 1;
                    var line_21 = data.LR2101 * 1;
                    var line_22 = data.LR2201 * 1;
                    var line_23 = data.LR2301 * 1;
                    var line_24 = data.LR2401 * 1;
                    var line_25 = data.LR2501 * 1;
                    var line_26 = data.LR2601 * 1;
                    var line_27 = data.LR2701 * 1;
                    var line_28 = data.LR2801 * 1;
                    var line_29 = data.LR2901 * 1;
                    var line_30 = data.LR3001 * 1;
                    var LR3501 = data.LR3501 * 1;
                    var LR3601 = data.LR3601 * 1;
                    var LR3701 = data.LR3701 * 1;
                    var misc_fees = LR3501 + LR3601 + LR3701;
                    var line_31 = line_19 + line_20 + line_21 + line_22 + line_23 + line_24 + line_25 + line_26 + line_27 + line_28 + line_29 + line_30 + misc_fees;
                    data.LR3101 = digits.format(line_31); //sum line 19-30

                    var line_32 = Math.round((line_7 + line_15 + line_18 + line_31) * 100)/100;
                    data.LR3201 = digits.format(line_32);
                    var line_33 = Math.round((line_32 * .03) * 100) / 100;
                    data.LR3301 = digits.format(line_33);
                    var line_34 = line_31 + line_33;
                    data.LR3401=digits.format(line_34); //sum of line 31 + 33

                    data.LR3501=digits.format(data.LR3501);
                    data.LR3601=digits.format(data.LR3601);
                    data.LR3701=digits.format(data.LR3701);
                    var total = (line_32.toFixed(2) * 1) + (line_33 * 1);
                    vm.grand_total=digits.format(total); //sum line 32 + 33

                    //assign to binding source...
                    vm.redemption_case = data;
                });
            this.nav_section = "details";
        },
        setupGrid() {
            let width = screen.width;
            var small_display = false;
            var num_results = 10;
            if (width < 600) {
                small_display = true;
                num_results = 5;
            }
            $("#search_grid").igGrid({
                width: "100%",
                autoGenerateColumns: false,
                autoAdjustHeight: true,
                primaryKey: "AssessHeaderId",
                columns: [{
                    key: "AssessHeaderId",
                    headerText: "ID",
                    dataType: "number",
                    hidden: true
                }, {
                    key: "Gin",
                    headerText: "Gin",
                    dataType: "number",
                    hidden: true
                }, {
                    key: "VoidFlag",
                    headerText: "Void",
                    dataType: "string",
                    hidden: true
                }, {
                    key: "Ppin",
                    headerText: "PPIN",
                    dataType: "string",
                }, {
                    key: "TaxYear",
                    headerText: "Year",
                    dataType: "string",
                    hidden: false,
                    template: "{{if ${VoidFlag} == 'Y' }}${TaxYear} - VOID{{else}}${TaxYear}{{/if}}"
                }, {
                    key: "ParcelNumber",
                    headerText: "Parcel",
                    dataType: "string"
                }, {
                    key: "OwnerAddress",
                    headerText: "Owner Address",
                    dataType: "string",
                    hidden: small_display
                }, {
                    key: "PropertyOwner",
                    headerText: "Owner Name",
                    dataType: "string",
                    hidden: false
                }, {
                    key: "SoldToName",
                    headerText: "Sold To",
                    dataType: "string",
                    hidden: small_display
                }, {
                    key: "Redeemer",
                    headerText: "Redeemer",
                    dataType: "string",
                    hidden: small_display
                }, {
                    key: "RedemptionDate",
                    headerText: "Redeemed",
                    dataType: "date"
                }, {
                    key: "RedemptionNumber",
                    headerText: "Receipt Num",
                    dataType: "string",
                    hidden: small_display
                }, {
                    key: "Conveyance",
                    headerText: "Conveyance",
                    dataType: "string",
                    hidden: small_display,
                    template: "{{if ${Conveyance} == 'true' }}Yes{{/if}}"
                }, {
                    key: "ExtendedLegal",
                    headerText: "Legal Description",
                    dataType: "string",
                    width: "300px",
                    hidden: true
                }],
                features: [{
                    name: "Sorting",
                    type: "local",
                    columnSettings: [
                        { columnKey: 'TaxYear', allowSorting: true, currentSortDirection: "desc" }
                    ]
                }, {
                    name: "Filtering",
                    type: "local",
                    filterDialogContainment: "window"
                }, {
                    name: "Hiding",
                }, {
                    name: "Paging",
                    pageSize: num_results
                }, {
                    name: "Resizing"
                }, {
                    name: "Selection",
                    mode: "row",
                    multipleSelection: false
                }, {
                    name: "Tooltips",
                    visibility: "always"
                }, {
                    name: "ColumnMoving",
                    columnMovingDialogContainment: "window"
                }]
            });
            $("#search_grid").on("iggridselectionrowselectionchanged", this.selectResult);
        },
        formatDate(server_format) {
            if (server_format == null) return "";
            if (server_format == "") return "";
            const status_date = new Date(parseInt(server_format.replace("/Date(", "").replace(")/", ""), 10));
            var display_date = (status_date.getMonth() + 1) + '/' + status_date.getDate() + '/' + status_date.getFullYear();
            return display_date;
        },
        monthDiff(d1, d2) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
        paySelectedItems() {
            var message = "Please fill in the following: "
            var valid = true;
            if (this.first_name == "") {
                message += " FirstName ";
                valid = false;
            }
            if (this.last_name == "") {
                message += " LastName ";
                valid = false;
            }
            if (this.email == "") {
                message += " Email ";
                valid = false;
            }
            if (this.Phone == "") {
                message += " Phone ";
                valid = false;
            }
            if (this.address == "") {
                message += " Address ";
                valid = false;
            }
            if (this.city == "") {
                message += " City ";
                valid = false;
            }
            if (this.state == "") {
                message += " State ";
                valid = false;
            }
            if (this.zip == "") {
                message += " Zip ";
                valid = false;
            }
            if (valid == false) {
                alert(message);
                return;
            }

            var arrYears = new Array();
            $('input[name="pay_year"]:checked').each(function () {
                var year = $(this).val();
                arrYears.push(year);
            });
            var vm = this;

            SearchAPI.checkout(this.redemption_case.Gin, this.first_name, this.last_name, this.address, this.city, this.state, this.zip, this.phone, this.email, arrYears, this.kl)
                .then(function (data) {
                    if (!data) return;

                    if ((data + "").indexOf("exception") > 0) {
                        data = JSON.parse(data);
                        alert("Please Note: " + data.exception);
                        return;
                    }
                    if (data.Status == 1) {
                        //already paid (with account)
                        var thankyou = SearchAPI.getBaseURL() + "Account/ThankYou/" + data.PrimaryKeyValue;
                        window.open(thankyou);
                        return;
                    }
                    if (data.Module == "NCOURT") {
                        vm.displayCheckout(data, false);
                    } else if (data.Module == "ION") {
                        vm.displayCheckout(data, false);
                    } else {
                        vm.displayCheckout(data, true);
                    }
                });
        },
        displayCheckout(data, appendTransID) {
            var text = "<div id='payment_div' style='height:800px;width:1100px'>";

            var arrYears = new Array();
            $('input[name="pay_year"]:checked').each(function () {
                var year = $(this).val();
                arrYears.push(year);
            });
            text += "<h4>Summary of Payment</h4>";
            text += "<hr />";
            var total = 0;
            for (var i = 0; i < data.AssessmentCollection.length; i++) {
                var desc = "PPIN: " + this.redemption_case.Ppin + " Parcel: " + this.redemption_case.ParcelNumber + " Year: " + arrYears[i];
                var num = data.AssessmentCollection[i].NumberOfPages;
                var cost = data.AssessmentCollection[i].Total;
                total += (cost * 1);

                text += "<div style='float:left;'>";
                text += desc + "...</div>";
                text += "<div style='float:right;'>$" + cost.toFixed(2) + "</div>";
                text += "<br clear='all' />";
            }
            //now tack on conviencence fee
            var extraFee = data.Module * 1;
            if (isNaN(extraFee)) extraFee = 0;

            if (extraFee > 0) {
                text += "<div style='float:left;'>";
                text += "CC Service Charge...</div>";
                text += "<div style='float:right;'>$" + extraFee.toFixed(2) + "</div>";
            }
            text += "<br clear='all' />";

            total += extraFee;

            text += "<hr />";
            text += "<div style='float:left;font-weight:bold;'>Total USD</div>";
            text += "<div style='float:right;font-weight:bold;'>$" + total.toFixed(2) + "</div>";
            text += "<br clear='all' />";
            text += "<hr />";
            text += "<br clear='all' />";

            var src = data.Comments;
            if (appendTransID) {
                src += "LEXISNEXIS_TRANSACTION_TOKEN=" + data.ReceiptNumber + "&CUSTOMER_TRANSACTION_TOKEN=" + data.PrimaryKeyValue;
            }
            text += "<iframe id='payment_frame' src='" + src + "' frameBorder='0' seamless='seamless' scrolling='auto' width='100%' height='80%'></iframe>";
            text += "</div>";

            //window.open(src);
            this.checkout_page_text = text;
            //document.getElementById("checkout-modal").setAttribute("checked", true);
            document.getElementById("checkout-modal").click();

            console.log("Opening checkout page: " + document.getElementById("checkout-modal").checked);
        },
        modalToggle() {
            var isChecked = document.getElementById("checkout-modal").checked;
            console.log("Checkout page toggle = " + isChecked);
            if (isChecked == false) {
                if (this.kiosk_mode == true && this.kl != "") {
                    //for kisok integration, route back to calling URL...
                    console.log("Redirecting to " + this.kl);
                    if (this.kl.indexOf("http") >= 0) {
                        window.location.href = this.kl;
                    } else {
                        window.location.href = "http://" + this.kl;
                    }
                } else {
                    //refresh onscreen list after close of modal input...
                    console.log("Refreshing case list...");
                    this.loadRedemptionCase(this.redemption_case.Gin, this.redemption_case.TaxYear);
                    this.loadAvailableAssessments(this.redemption_case.Gin);
                    this.nav_section = "details";
                }
            }
        },
        clearSearch() {
            this.criteria_ppin = "";
            this.criteria_year = "";
            this.criteria_name = "";
            this.criteria_parcel = "";
            this.criteria_unredeemed = false;
            $("#search_grid").igGrid("dataSourceObject", []);
            $("#search_grid").igGrid("dataBind");
        },
        isAvailableForPayment() {
            return this.redemption_case.RedemptionDate == null && this.redemption_case.MaturedToStateFlag == 'N' && this.has_credit_card_merchant;
        },
        exportResults(type) {
            if (this.criteria_ppin == "" && this.criteria_name == "" && this.criteria_parcel == "") {
                alert("Please enter additional criteria before searching.");
                return;
            }
            var search_user_id = "1011"; //this is static (for now)
            if (this.criteria_ppin != "") {
                this.criteria_ppin = this.criteria_ppin * 1; //make it numeric to drop leading zero
            }
            //output will be a new window with embedded PDF...
            SearchAPI.exportResults(search_user_id, this.criteria_ppin, this.criteria_year, this.criteria_parcel, this.criteria_name, this.criteria_unredeemed, this.kiosk_mode, type)
            return;
        }
    }
}
</script>

